module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.detectMobile()) ? _c('div', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.listExercises(_vm.group)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('h3', {
    staticClass: "info-box-number",
    style: (_vm.hideProgress ? 'margin-top: 5px' : '')
  }, [_c('div', {
    staticClass: "dropdown pull-right",
    style: (_vm.hideProgress ? 'margin-top: -5px' : ''),
    attrs: {
      "id": 'dropdown-' + _vm.jIndeks
    }
  }, [(!_vm.group.isEnrolled) ? _c('button', {
    staticClass: "btn btn-secondary dropdownMenuButton",
    attrs: {
      "id": 'dropdownMenuButton-' + _vm.jIndeks
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.joinYear(_vm.group)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.group.joinGroup')))])]) : _vm._e(), _vm._v(" "), (_vm.jeAdmin || _vm.group.enrollmentId) ? _c('button', {
    staticClass: "btn btn-secondary dropdown-toggle dropdownMenuButton",
    attrs: {
      "id": 'dropdownMenuButton-' + _vm.jIndeks,
      "aria-haspopup": "true",
      "aria-expanded": "false",
      "data-toggle": "dropdown"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.toggleDropdown(_vm.jIndeks, _vm.groupListLength)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-cog"
  }), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu",
      "id": _vm.group.groupId
    }
  }, [(_vm.jeAdmin) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.editGroup(_vm.group)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.group.editGroup')))])]) : _vm._e(), _vm._v(" "), (_vm.jeAdmin) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.editYear(_vm.group)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.group.editYear')))])]) : _vm._e(), _vm._v(" "), (_vm.jeAdmin) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.createYear(_vm.group)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.group.createYear')))])]) : _vm._e(), _vm._v(" "), (_vm.group.enrollmentId) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.disEnroll(_vm.group)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.group.leaveGroup')))])]) : _vm._e()])]), _vm._v("\n        " + _vm._s(_vm._f("pickTranslation")(_vm.group.groupName)) + "\n        "), (_vm.showYear) ? _c('span', [_vm._v(" (" + _vm._s(_vm.group.yearName) + ")")]) : _vm._e(), _vm._v(" "), (_vm.group.isOwner) ? _c('div', {
    staticClass: "badge bg-blue"
  }, [_vm._v(_vm._s(_vm.$t('pages.group.owner')))]) : _vm._e(), _vm._v(" "), (_vm.group.isEnrolled) ? _c('div', {
    staticClass: "badge bg-green"
  }, [_vm._v(_vm._s(_vm.$t('pages.group.enrolled')))]) : _vm._e(), _vm._v(" "), (_vm.group.isPending) ? _c('div', {
    staticClass: "badge bg-red"
  }, [_vm._v(_vm._s(_vm.$t('pages.group.pending')))]) : _vm._e(), _vm._v(" "), (_vm.group.isArchived) ? _c('div', {
    staticClass: "badge bg-black"
  }, [_vm._v(_vm._s(_vm.$t('pages.group.archived')))]) : _vm._e()]), _vm._v(" "), (!_vm.hideProgress) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    style: ({
      width: (_vm.group.solvedSubgroupsCount / _vm.group.subgroupsCount) * 100 + '%'
    })
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "progress-description"
  }, [_vm._v("\n        " + _vm._s(_vm._f("pickTranslation")(_vm.group.groupDescription)) + "\n      ")])])]) : _c('div', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.listExercises(_vm.group)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('h3', {
    staticClass: "small-margin-text info-box-number small-title"
  }, [_c('div', {
    staticClass: "dropdown pull-right",
    attrs: {
      "id": 'dropdown-' + _vm.jIndeks
    }
  }, [(!_vm.group.isEnrolled) ? _c('button', {
    staticClass: "btn btn-secondary btn-sm dropdownMenuButton",
    attrs: {
      "id": 'dropdownMenuButton-' + _vm.jIndeks,
      "title": _vm.$t('pages.group.joinGroup')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.joinYear(_vm.group)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus",
    staticStyle: {
      "margin-right": "0 !important"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.jeAdmin || _vm.group.enrollmentId) ? _c('button', {
    staticClass: "btn btn-secondary dropdown-toggle btn-sm dropdownMenuButton",
    attrs: {
      "id": 'dropdownMenuButton-' + _vm.jIndeks,
      "aria-haspopup": "true",
      "aria-expanded": "false",
      "data-toggle": "dropdown"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.toggleDropdown(_vm.jIndeks, _vm.groupListLength)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-cog"
  }), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu",
      "id": _vm.group.groupId
    }
  }, [(_vm.group.enrollmentId) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.disEnroll(_vm.group)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.group.leaveGroup')))])]) : _vm._e(), _vm._v(" "), (_vm.jeAdmin) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.editGroup(_vm.group)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.group.editGroup')))])]) : _vm._e(), _vm._v(" "), (_vm.jeAdmin) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.editYear(_vm.group)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.group.editYear')))])]) : _vm._e(), _vm._v(" "), (_vm.jeAdmin) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.createYear(_vm.group)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.group.createYear')))])]) : _vm._e()])]), _vm._v("\n        " + _vm._s(_vm._f("pickTranslation")(_vm.group.groupName)) + "\n        "), (_vm.showYear) ? _c('span', [_vm._v(" (" + _vm._s(_vm.group.yearName) + ")")]) : _vm._e()]), _vm._v(" "), (!_vm.hideProgress) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    style: ({
      width: (_vm.group.solvedSubgroupsCount / _vm.group.subgroupsCount) * 100 + '%'
    })
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "small-margin-text progress-description",
    style: (_vm.hideProgress ? 'margin-top: 5px' : '')
  }, [_vm._v("\n        " + _vm._s(_vm._f("pickTranslation")(_vm.group.groupDescription)) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-danger fade",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "modal-await"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(1), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t("pages.group.await")))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("\n            " + _vm._s(_vm.$t("pages.group.awaitModalOne")) + "\n            " + _vm._s(_vm.$t("pages.group.awaitModalTwo")) + "\n          ")])]), _vm._v(" "), _vm._m(2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon"
  }, [_c('i', {
    staticClass: "fa fa-graduation-cap "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-outline",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-77d9f3f6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77d9f3f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/groups/GroupTemplate.vue
// module id = 1416
// module chunks = 1